module.exports = __webpack_public_path__ + "static/media/Rainbow spinner.372cb37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wordMark2/Rainbow spinner.png
// module id = 859
// module chunks = 0